function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReconciliationAuthBg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 900,
    viewBox: "0 0 1440 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23065_21773)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 900,
    fill: "#EEF3FC",
    style: {
      fill: "#EEF3FC",
      fill: "color(display-p3 0.9333 0.9529 0.9882)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1512.49 1250.15L1010.65 1434.91C978.129 1446.67 943.364 1423.15 943.364 1388.44L941.682 892.952C941.682 872.236 954.579 853.201 974.204 845.922L1476.04 661.163C1508.57 649.406 1543.33 672.921 1543.33 707.633L1545.01 1203.12C1545.01 1224.4 1532.12 1242.87 1512.49 1250.15Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.493 1393.48L970.839 901.35C970.279 880.075 983.175 861.039 1002.8 853.201L1501.28 665.642C1533.8 653.325 1568.56 676.84 1569.12 711.552L1579.78 1203.68C1580.34 1224.96 1567.44 1243.99 1547.82 1251.83L1049.34 1439.39C1016.82 1451.71 982.054 1428.19 981.493 1393.48Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.4861,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.62 1398.52L1000.56 909.188C999.436 887.913 1011.77 867.757 1031.96 859.919L1527.07 669.561C1559.03 657.244 1593.79 680.199 1595.48 714.352L1614.54 1203.68C1615.66 1224.96 1603.33 1245.11 1583.14 1252.95L1088.03 1443.31C1056.07 1455.63 1021.3 1432.67 1019.62 1398.52Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.4723,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.31 1404.12L1030.28 918.146C1028.59 896.871 1040.93 876.155 1061.11 867.757L1553.42 674.6C1585.38 662.283 1620.15 684.118 1622.39 718.271L1650.43 1204.24C1652.11 1225.52 1639.77 1246.23 1619.59 1254.63L1127.28 1447.79C1094.76 1460.11 1059.99 1437.71 1058.31 1404.12Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.4584,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1096.44 1409.16L1059.99 925.984C1057.75 904.149 1070.09 883.434 1090.27 874.476L1579.22 678.519C1611.18 665.642 1645.94 687.477 1648.18 721.07L1684.63 1204.24C1686.87 1226.08 1674.54 1246.79 1654.35 1255.75L1165.41 1451.71C1134.01 1464.58 1098.68 1442.75 1096.44 1409.16Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.4446,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.57 1414.2L1089.15 933.823C1086.35 911.988 1098.12 890.152 1118.87 881.194L1604.45 682.439C1635.85 669.561 1671.17 690.837 1673.98 723.869L1719.4 1204.24C1722.2 1226.08 1710.42 1247.91 1689.68 1256.87L1204.1 1455.63C1172.7 1469.06 1137.93 1447.79 1134.57 1414.2Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.4307,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1173.26 1419.79L1119.43 942.781C1116.06 920.945 1127.84 898.55 1148.59 889.033L1630.8 687.477C1662.2 674.04 1697.53 694.756 1700.89 728.348L1754.72 1205.36C1758.08 1227.2 1746.31 1249.59 1725.56 1259.11L1243.35 1460.67C1211.39 1473.54 1176.62 1452.83 1173.26 1419.79Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.4169,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1211.39 1424.83L1148.59 950.619C1144.66 928.224 1155.88 905.269 1177.74 895.751L1657.16 691.396C1688.56 677.959 1723.32 698.115 1727.81 731.148L1790.61 1205.36C1794.53 1227.76 1783.32 1250.71 1761.45 1260.23L1282.04 1464.58C1250.64 1478.02 1215.31 1457.87 1211.39 1424.83Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.403,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.52 1429.87L1178.3 959.017C1173.82 936.622 1185.03 913.107 1206.9 903.029L1682.95 695.875C1713.79 682.438 1749.11 702.034 1754.16 734.507L1825.37 1205.36C1829.86 1227.76 1818.64 1251.27 1796.77 1261.35L1320.73 1468.5C1289.33 1482.5 1254.56 1462.91 1249.52 1429.87Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3892,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.2 1435.47L1208.02 967.415C1202.98 944.46 1214.19 920.946 1236.06 910.308L1708.74 700.355C1739.58 686.358 1774.91 705.393 1779.95 737.866L1860.14 1205.92C1865.18 1228.88 1853.97 1252.39 1832.1 1263.03L1359.42 1472.98C1328.58 1486.98 1293.25 1467.38 1288.2 1435.47Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3753,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.33 1440.51L1237.74 975.813C1231.57 952.858 1242.79 928.224 1265.22 917.586L1734.53 704.834C1765.37 690.837 1800.7 709.312 1806.31 741.785L1894.9 1206.48C1901.07 1229.44 1889.85 1254.07 1867.42 1264.71L1398.11 1477.46C1367.27 1490.9 1332.5 1472.42 1326.33 1440.51Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3615,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1364.46 1445.55L1266.9 983.652C1260.17 960.697 1271.38 935.502 1293.81 924.305L1760.33 708.753C1790.61 694.756 1825.93 712.672 1832.66 744.585L1930.22 1206.48C1936.95 1229.44 1925.74 1254.63 1903.31 1265.83L1436.79 1481.38C1406.52 1495.38 1371.19 1477.46 1364.46 1445.55Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3476,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1403.15 1450.59L1297.18 991.49C1289.89 967.975 1301.1 942.781 1323.53 931.023L1786.68 712.672C1816.96 698.115 1852.29 715.471 1859.57 747.384L1965.55 1206.48C1972.84 1230 1961.62 1255.19 1939.2 1266.95L1476.04 1485.3C1445.21 1499.86 1409.88 1482.5 1403.15 1450.59Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1441.28 1456.19L1326.33 1000.45C1318.48 976.933 1329.14 950.619 1352.13 938.862L1811.91 717.711C1842.19 703.154 1877.52 719.95 1885.37 751.303L2000.31 1207.04C2008.16 1230.56 1997.51 1256.87 1974.52 1268.63L1514.73 1489.78C1484.46 1504.34 1449.13 1487.54 1441.28 1456.19Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3199,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1479.41 1461.23L1356.05 1008.29C1347.64 984.771 1358.29 957.897 1381.28 945.58L1837.71 721.63C1867.99 707.073 1903.31 723.309 1911.72 754.103L2035.08 1207.04C2043.49 1230.56 2032.84 1257.43 2009.85 1269.75L1553.42 1493.7C1523.14 1508.81 1487.82 1492.58 1479.41 1461.23Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3061,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1518.1 1466.26L1385.77 1016.68C1376.8 992.61 1386.89 965.736 1410.44 952.858L1864.06 726.109C1893.78 710.992 1929.66 726.669 1938.07 758.022L2070.4 1207.6C2079.38 1231.68 2069.28 1258.55 2045.73 1271.43L1592.11 1498.18C1562.39 1513.29 1526.51 1497.62 1518.1 1466.26Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.2922,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1556.23 1471.86L1415.49 1025.08C1405.96 1001.01 1416.05 973.014 1439.6 960.137L1889.85 730.588C1919.57 715.471 1954.9 730.588 1964.43 761.381L2105.17 1208.16C2114.7 1232.24 2104.61 1260.23 2081.06 1273.11L1630.8 1502.66C1601.08 1517.77 1565.76 1502.1 1556.23 1471.86Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.2783,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1594.36 1476.9L1444.64 1032.92C1434.55 1008.85 1444.64 980.292 1468.19 966.855L1915.09 734.507C1944.8 719.39 1980.13 733.947 1990.22 764.18L2139.93 1208.16C2150.03 1232.24 2139.93 1260.79 2116.38 1274.23L1669.49 1506.58C1640.33 1522.25 1604.45 1507.14 1594.36 1476.9Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.2645,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460.491 1394.15L-41.3498 1578.91C-73.8713 1590.67 -108.636 1567.15 -108.636 1532.44L-110.318 1036.95C-110.318 1016.24 -97.4214 997.201 -77.7963 989.922L424.045 805.163C456.566 793.406 491.331 816.921 491.331 851.633L493.013 1347.12C493.013 1368.4 480.116 1386.87 460.491 1394.15Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-70.507 1537.48L-81.1606 1045.35C-81.7214 1024.07 -68.8249 1005.04 -49.1998 997.201L449.277 809.642C481.798 797.325 516.563 820.84 517.124 855.552L527.777 1347.68C528.338 1368.96 515.441 1387.99 495.816 1395.83L-2.66037 1583.39C-35.1819 1595.71 -69.9463 1572.19 -70.507 1537.48Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.4861,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-32.3783 1542.52L-51.4427 1053.19C-52.5641 1031.91 -40.2284 1011.76 -20.0426 1003.92L475.07 813.561C507.031 801.244 541.795 824.199 543.477 858.352L562.542 1347.68C563.663 1368.96 551.327 1389.11 531.141 1396.95L36.029 1587.31C4.06821 1599.63 -30.6962 1576.67 -32.3783 1542.52Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.4723,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.31112 1548.12L-21.7247 1062.15C-23.4068 1040.87 -11.0711 1020.16 9.11471 1011.76L501.424 818.6C533.384 806.283 568.149 828.118 570.392 862.271L598.427 1348.24C600.11 1369.52 587.774 1390.23 567.588 1398.63L75.2792 1591.79C42.7577 1604.11 7.99327 1581.71 6.31112 1548.12Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.4584,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4398 1553.16L7.99326 1069.98C5.7504 1048.15 18.0862 1027.43 38.2719 1018.48L527.216 822.519C559.177 809.642 593.942 831.477 596.185 865.07L632.631 1348.24C634.874 1370.08 622.538 1390.79 602.352 1399.75L113.408 1595.71C82.0078 1608.58 46.6827 1586.75 44.4398 1553.16Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.4446,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5685 1558.2L37.1505 1077.82C34.3469 1055.99 46.1219 1034.15 66.8684 1025.19L552.449 826.439C583.849 813.561 619.174 834.837 621.977 867.869L667.395 1348.24C670.199 1370.08 658.424 1391.91 637.677 1400.87L152.097 1599.63C120.697 1613.06 85.9328 1591.79 82.5685 1558.2Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.4307,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.258 1563.79L67.4291 1086.78C64.0648 1064.95 75.8398 1042.55 96.5863 1033.03L578.802 831.477C610.202 818.04 645.527 838.756 648.892 872.348L702.72 1349.36C706.085 1371.2 694.31 1393.59 673.563 1403.11L191.347 1604.67C159.387 1617.54 124.622 1596.83 121.258 1563.79Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.4169,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.387 1568.83L96.5864 1094.62C92.6614 1072.22 103.876 1049.27 125.744 1039.75L605.156 835.396C636.556 821.959 671.32 842.115 675.806 875.148L738.606 1349.36C742.531 1371.76 731.317 1394.71 709.449 1404.23L230.037 1608.58C198.637 1622.02 163.312 1601.87 159.387 1568.83Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.403,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.515 1573.87L126.304 1103.02C121.819 1080.62 133.033 1057.11 154.901 1047.03L630.949 839.875C661.788 826.438 697.113 846.034 702.16 878.507L773.371 1349.36C777.856 1371.76 766.642 1395.27 744.774 1405.35L268.726 1612.5C237.326 1626.5 202.562 1606.91 197.515 1573.87Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3892,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.205 1579.47L156.022 1111.42C150.976 1088.46 162.19 1064.95 184.058 1054.31L656.742 844.355C687.581 830.358 722.906 849.393 727.953 881.866L808.135 1349.92C813.182 1372.88 801.967 1396.39 780.099 1407.03L307.416 1616.98C276.576 1630.98 241.251 1611.38 236.205 1579.47Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3753,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.334 1584.51L185.74 1119.81C179.572 1096.86 190.787 1072.22 213.215 1061.59L682.535 848.834C713.374 834.837 748.699 853.312 754.307 885.785L842.9 1350.48C849.068 1373.44 837.853 1398.07 815.425 1408.71L346.105 1621.46C315.266 1634.9 280.501 1616.42 274.334 1584.51Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3615,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.462 1589.55L214.898 1127.65C208.169 1104.7 219.383 1079.5 241.812 1068.3L708.328 852.753C738.606 838.756 773.931 856.672 780.66 888.585L878.225 1350.48C884.953 1373.44 873.739 1398.63 851.31 1409.83L384.795 1625.38C354.516 1639.38 319.191 1621.46 312.462 1589.55Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3476,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.152 1594.59L245.176 1135.49C237.887 1111.98 249.101 1086.78 271.53 1075.02L734.681 856.672C764.96 842.115 800.285 859.471 807.574 891.384L913.55 1350.48C920.839 1374 909.625 1399.19 887.196 1410.95L424.045 1629.3C393.205 1643.86 357.88 1626.5 351.152 1594.59Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.28 1600.19L274.333 1144.45C266.483 1120.93 277.137 1094.62 300.126 1082.86L759.914 861.711C790.192 847.154 825.518 863.95 833.368 895.303L948.314 1351.04C956.164 1374.56 945.511 1400.87 922.521 1412.63L462.734 1633.78C432.455 1648.34 397.13 1631.54 389.28 1600.19Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3199,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.409 1605.23L304.051 1152.29C295.641 1128.77 306.294 1101.9 329.284 1089.58L785.707 865.63C815.985 851.073 851.31 867.309 859.721 898.103L983.079 1351.04C991.489 1374.56 980.836 1401.43 957.847 1413.75L501.424 1637.7C471.145 1652.81 435.82 1636.58 427.409 1605.23Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3061,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.098 1610.26L333.769 1160.68C324.798 1136.61 334.891 1109.74 358.441 1096.86L812.06 870.109C841.778 854.992 877.664 870.669 886.075 902.022L1018.4 1351.6C1027.38 1375.68 1017.28 1402.55 993.732 1415.43L540.113 1642.18C510.395 1657.29 474.509 1641.62 466.098 1610.26Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.2922,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.227 1615.86L363.487 1169.08C353.955 1145.01 364.048 1117.01 387.598 1104.14L837.853 874.588C867.571 859.471 902.896 874.588 912.428 905.381L1053.17 1352.16C1062.7 1376.24 1052.61 1404.23 1029.06 1417.11L578.802 1646.66C549.084 1661.77 513.759 1646.1 504.227 1615.86Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.2783,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.356 1620.9L392.644 1176.92C382.552 1152.85 392.644 1124.29 416.195 1110.86L863.085 878.507C892.803 863.39 928.128 877.947 938.221 908.18L1087.93 1352.16C1098.03 1376.24 1087.93 1404.79 1064.38 1418.23L617.492 1650.58C588.334 1666.25 552.449 1651.14 542.356 1620.9Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.2645,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.045 1625.94L422.923 1185.32C412.27 1160.68 421.802 1132.13 445.912 1118.13L889.439 882.986C918.596 867.309 954.482 881.866 965.136 911.54L1123.26 1352.16C1133.91 1376.8 1124.38 1405.35 1100.27 1419.35L656.742 1654.49C627.024 1670.17 591.138 1656.17 581.045 1625.94Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.2506,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.174 1631.54L452.08 1193.72C440.866 1169.08 450.398 1139.41 474.509 1125.41L915.232 887.465C944.389 871.788 980.275 885.225 991.489 915.459L1158.58 1353.28C1169.8 1377.92 1160.27 1407.59 1136.15 1421.59L695.431 1658.97C666.274 1674.65 630.388 1661.21 619.174 1631.54Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.2368,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.303 1636.58L481.798 1202.11C470.023 1177.48 478.995 1147.25 503.666 1132.69L941.025 891.944C970.182 876.267 1005.51 889.145 1017.28 918.818L1192.79 1353.28C1204.56 1377.92 1195.59 1408.15 1170.92 1422.71L733.56 1663.45C704.963 1679.13 669.078 1666.25 657.303 1636.58Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.2229,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.992 1641.62L511.516 1209.95C499.181 1184.76 508.152 1154.53 532.824 1139.41L966.818 896.423C995.414 880.187 1031.3 893.064 1043.64 922.177L1228.11 1353.84C1240.45 1379.04 1231.48 1409.27 1206.8 1424.39L772.81 1667.37C744.214 1683.61 708.328 1671.29 695.992 1641.62Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.2091,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.121 1646.66L540.674 1217.79C527.777 1192.6 536.749 1161.24 561.42 1146.13L992.05 900.342C1020.65 884.106 1056.53 895.863 1069.43 924.977L1262.88 1353.84C1275.77 1379.04 1266.8 1410.39 1242.13 1425.51L811.5 1671.29C782.903 1688.09 747.017 1675.77 734.121 1646.66Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.1952,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.249 1652.25L570.392 1226.75C556.934 1201.56 565.345 1169.64 590.577 1153.97L1018.4 905.381C1047 888.585 1082.89 900.342 1096.34 928.896L1298.2 1354.4C1311.66 1379.6 1303.25 1411.51 1278.02 1427.18L850.189 1675.77C822.153 1692.57 785.707 1680.81 772.249 1652.25Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.1814,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.939 1657.29L600.109 1234.59C586.092 1208.83 594.502 1176.36 619.735 1160.68L1044.2 909.3C1072.23 892.504 1108.68 903.701 1122.7 932.255L1333.53 1354.96C1347.54 1380.72 1339.13 1413.19 1313.9 1428.86L889.439 1680.25C860.843 1697.05 824.957 1685.85 810.939 1657.29Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.1675,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.067 1662.33L629.827 1242.99C615.249 1217.23 623.66 1184.2 648.892 1167.96L1069.99 913.779C1098.03 896.983 1133.91 907.061 1149.05 935.614L1368.29 1354.96C1382.87 1380.72 1374.46 1413.75 1349.23 1429.98L928.128 1684.17C899.532 1701.52 863.646 1690.89 849.067 1662.33Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.1537,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1104.75 1641.06C1103.63 1640.5 848.507 1264.26 848.507 1262.58C831.685 1237.39 837.853 1170.76 863.085 1153.97C863.085 1152.29 1241.01 896.983 1242.69 897.543C1267.92 880.746 1334.65 895.303 1352.03 920.498C1353.15 921.058 1608.28 1297.29 1608.28 1298.97C1625.1 1324.17 1618.93 1390.79 1593.7 1407.59C1593.7 1409.27 1215.78 1664.57 1214.09 1664.01C1188.86 1681.37 1121.58 1666.25 1104.75 1641.06Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.1305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1117.65 1615.3C1115.41 1614.74 869.253 1250.82 869.253 1248.58C852.993 1224.51 859.16 1142.21 883.271 1125.97C883.271 1123.17 1248.86 876.267 1251.66 876.827C1275.77 860.591 1358.2 879.067 1374.46 903.701C1376.7 904.261 1622.86 1268.18 1622.86 1270.42C1639.12 1294.49 1632.95 1376.8 1608.84 1393.03C1608.84 1395.83 1243.25 1642.74 1240.45 1642.18C1216.34 1658.41 1133.91 1639.38 1117.65 1615.3Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.1605,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130.55 1588.99C1127.74 1588.43 889.439 1236.27 889.439 1233.47C873.739 1209.95 879.346 1113.09 902.896 1097.42C902.896 1093.5 1256.71 854.432 1260.63 855.552C1284.18 839.876 1381.75 862.83 1397.45 885.785C1400.25 886.345 1638.56 1238.51 1638.56 1241.31C1654.26 1264.82 1648.65 1361.68 1625.1 1377.36C1625.1 1381.28 1271.29 1620.34 1267.36 1619.22C1243.81 1634.9 1146.25 1611.94 1130.55 1588.99Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.1905,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143.44 1562.67C1140.08 1562.11 910.185 1222.27 910.185 1218.91C895.046 1196.52 900.653 1083.98 923.082 1068.86C923.082 1063.83 1264.56 833.157 1269.6 834.277C1292.03 819.16 1404.74 846.034 1419.88 868.429C1423.24 868.989 1653.13 1208.83 1653.13 1212.19C1668.27 1234.59 1662.67 1347.12 1640.24 1362.24C1640.24 1367.28 1298.76 1597.95 1293.72 1596.83C1271.29 1611.94 1158.58 1585.07 1143.44 1562.67Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.2205,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1156.34 1536.36C1152.41 1535.24 930.932 1208.27 930.371 1203.79C915.792 1181.96 920.839 1054.87 942.707 1040.31C942.707 1034.71 1272.41 811.322 1278.02 813.002C1299.88 798.445 1427.73 829.238 1442.31 850.513C1446.23 851.633 1667.71 1178.6 1668.27 1183.08C1682.85 1204.91 1677.81 1332.01 1655.94 1346.56C1655.94 1352.16 1326.24 1575.55 1320.63 1573.87C1298.76 1588.43 1170.92 1558.2 1156.34 1536.36Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.2504,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1169.24 1510.05C1164.75 1508.93 951.118 1194.28 951.118 1189.24C937.1 1168.52 942.146 1025.75 962.893 1011.76C962.893 1005.04 1280.26 790.047 1286.99 791.726C1307.73 777.729 1450.72 812.442 1464.73 833.157C1469.22 834.277 1682.85 1148.93 1682.85 1153.97C1696.87 1174.68 1691.82 1317.45 1671.08 1331.45C1671.08 1338.16 1353.71 1553.16 1346.98 1551.48C1326.8 1565.47 1183.25 1530.76 1169.24 1510.05Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.2804,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1182.13 1483.73C1177.09 1482.61 971.864 1179.72 971.864 1174.68C958.407 1154.53 962.893 997.201 983.079 983.764C983.079 975.925 1288.67 769.331 1295.96 771.011C1316.14 757.574 1474.27 796.205 1487.72 815.801C1492.77 816.921 1697.99 1119.81 1697.99 1124.85C1711.45 1145.01 1706.96 1302.33 1686.78 1315.77C1686.78 1323.61 1381.19 1530.2 1373.9 1528.52C1354.27 1542.52 1195.59 1503.89 1182.13 1483.73Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3104,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1195.03 1457.42C1188.86 1455.74 992.05 1165.72 992.05 1159.56C979.153 1140.53 983.639 967.527 1002.7 954.65C1002.7 945.692 1295.96 746.936 1304.93 749.176C1323.99 736.299 1497.82 778.849 1510.71 797.885C1516.88 799.564 1713.69 1089.58 1713.69 1095.74C1726.59 1114.77 1722.1 1287.78 1703.04 1300.65C1703.04 1309.61 1409.78 1508.37 1400.81 1506.13C1381.75 1519 1207.93 1476.45 1195.03 1457.42Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3404,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1207.93 1431.1C1201.2 1429.42 1012.8 1151.73 1012.8 1145.01C1000.46 1127.09 1004.95 938.973 1022.89 926.656C1022.89 917.138 1304.37 726.221 1313.9 728.46C1331.84 716.143 1520.81 762.613 1533.14 780.529C1539.87 782.208 1728.27 1059.91 1728.27 1066.63C1740.61 1084.54 1736.12 1272.66 1718.18 1284.98C1718.18 1294.49 1436.7 1485.41 1427.17 1483.17C1409.22 1496.05 1220.26 1449.58 1207.93 1431.1Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3704,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1220.82 1404.79C1213.53 1403.11 1033.54 1137.73 1033.54 1129.89C1021.77 1112.53 1025.69 909.3 1043.08 898.103C1043.08 887.465 1312.22 704.386 1322.87 707.185C1340.25 695.428 1544.36 745.816 1556.13 763.173C1563.42 764.852 1743.41 1030.23 1743.41 1038.07C1755.18 1055.43 1751.26 1258.66 1733.88 1269.86C1733.88 1280.5 1464.73 1463.58 1454.08 1460.78C1436.7 1472.53 1232.6 1422.15 1220.82 1404.79Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.4003,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.72 1378.48C1225.87 1376.24 1053.73 1123.17 1053.73 1115.33C1042.51 1099.1 1046.44 880.746 1062.7 869.549C1062.7 857.792 1320.07 683.11 1331.28 685.91C1347.54 674.712 1567.34 729.02 1578 745.816C1585.85 748.056 1757.99 1001.12 1757.99 1008.96C1769.2 1025.19 1765.28 1243.55 1749.02 1254.74C1749.02 1266.5 1491.65 1441.18 1480.43 1438.38C1464.17 1449.58 1244.93 1395.27 1233.72 1378.48Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.4303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.18 1352.72C1238.77 1350.48 1075.04 1109.74 1075.04 1100.78C1064.38 1085.1 1067.75 851.633 1083.45 841.555C1083.45 828.678 1328.48 662.395 1340.82 665.194C1356.52 654.557 1590.89 712.784 1601.55 728.46C1609.96 730.7 1773.69 971.446 1773.69 980.404C1784.34 996.081 1780.98 1229.55 1765.28 1239.63C1765.28 1252.5 1520.24 1418.79 1507.91 1415.99C1492.21 1426.07 1257.27 1367.84 1247.18 1352.72Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.4603,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.07 1326.41C1250.54 1324.17 1095.22 1095.74 1095.22 1086.22C1085.13 1071.66 1088.49 823.079 1103.07 813.001C1103.07 799.564 1336.33 640.56 1349.79 643.919C1364.37 633.841 1614.44 695.987 1624.54 711.104C1634.07 713.344 1789.39 941.773 1789.39 951.291C1799.48 965.847 1796.12 1214.43 1781.54 1224.51C1781.54 1237.95 1548.28 1396.95 1534.82 1393.59C1519.68 1403.11 1269.6 1340.96 1260.07 1326.41Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.4903,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1272.97 1300.09C1262.88 1297.85 1115.97 1081.74 1115.97 1071.1C1106.44 1057.11 1109.24 793.406 1123.26 784.448C1123.26 769.891 1344.18 619.285 1358.76 622.644C1372.78 613.126 1637.43 679.191 1646.97 693.188C1657.06 695.428 1803.97 911.54 1803.97 922.177C1813.5 936.174 1810.7 1199.88 1796.68 1208.83C1796.68 1223.39 1575.76 1374 1561.18 1370.64C1547.16 1380.16 1281.94 1314.09 1272.97 1300.09Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.5203,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1285.87 1273.78C1275.21 1270.98 1136.71 1067.18 1136.71 1056.55C1127.74 1043.67 1130.55 764.852 1143.44 755.894C1143.44 740.218 1352.59 597.449 1367.73 601.368C1380.63 592.41 1660.98 662.395 1669.96 675.832C1680.61 678.631 1819.11 882.426 1819.11 893.064C1828.08 905.941 1825.27 1184.76 1812.38 1193.72C1812.38 1209.39 1603.23 1352.16 1588.09 1348.24C1574.63 1356.64 1294.28 1286.66 1285.87 1273.78Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.5503,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.76 1247.46C1287.55 1244.67 1156.9 1053.19 1156.9 1041.43C1148.49 1029.11 1150.73 735.179 1163.07 727.341C1163.07 710.544 1360.44 576.174 1376.14 580.093C1388.48 571.695 1683.97 646.159 1691.82 657.916C1703.04 660.715 1833.69 852.193 1833.69 863.95C1842.1 876.267 1839.85 1170.2 1827.52 1178.04C1827.52 1194.84 1630.15 1329.21 1614.44 1325.29C1602.11 1333.69 1306.61 1259.78 1298.76 1247.46Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.5802,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1311.66 1221.15C1299.88 1218.35 1177.65 1039.19 1177.65 1026.87C1169.8 1015.68 1172.04 706.625 1183.25 698.787C1183.25 681.431 1368.29 554.339 1385.11 558.818C1396.33 550.98 1706.96 629.362 1714.81 640.56C1726.59 643.359 1848.82 822.519 1848.82 834.837C1856.67 846.034 1854.43 1155.09 1843.22 1162.92C1843.22 1180.28 1658.18 1307.37 1641.36 1302.89C1630.15 1310.17 1318.95 1232.35 1311.66 1221.15Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.6102,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1324.55 1194.84C1312.22 1191.48 1197.83 1025.19 1197.83 1012.32C1190.54 1001.68 1192.23 677.512 1202.88 670.793C1202.88 652.317 1376.14 533.623 1394.08 538.102C1404.74 530.824 1730.51 613.126 1737.24 623.204C1749.58 626.563 1863.96 792.846 1863.96 805.723C1871.25 816.361 1869.57 1140.53 1858.92 1147.25C1858.92 1165.72 1685.66 1284.42 1667.71 1279.94C1657.62 1287.22 1331.28 1205.47 1324.55 1194.84Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.6402,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1337.45 1168.52C1323.99 1165.16 1218.58 1010.64 1218.58 997.201C1212.41 987.683 1213.53 648.398 1223.07 641.68C1223.07 622.084 1383.99 511.788 1403.05 516.267C1412.59 510.109 1754.06 595.77 1760.23 605.288C1773.69 608.647 1879.1 763.172 1879.1 776.61C1885.27 786.127 1884.15 1125.41 1874.62 1132.13C1874.62 1151.73 1713.69 1262.02 1694.63 1257.54C1685.1 1264.26 1343.62 1178.04 1337.45 1168.52Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.6702,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1350.35 1142.21C1336.33 1138.85 1239.33 996.641 1239.33 982.644C1233.72 974.246 1234.28 619.284 1243.25 613.686C1243.25 592.97 1392.4 490.513 1412.03 495.552C1420.44 489.953 1777.05 579.533 1783.22 587.931C1797.24 591.291 1894.24 733.499 1894.24 747.496C1899.85 755.894 1899.29 1110.86 1890.32 1116.45C1890.32 1137.17 1741.17 1239.63 1721.54 1234.59C1712.57 1240.75 1355.95 1151.17 1350.35 1142.21Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.7002,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.24 1116.45C1348.67 1112.53 1259.51 983.204 1259.51 968.087C1254.47 960.249 1255.03 590.731 1262.88 585.692C1262.88 564.417 1399.69 469.798 1420.44 474.837C1428.29 469.238 1800.04 563.297 1805.65 571.135C1820.23 575.054 1909.38 704.386 1909.38 719.502C1914.43 727.341 1913.87 1096.86 1906.02 1101.9C1906.02 1123.17 1769.2 1217.79 1748.46 1212.75C1740.05 1217.79 1368.29 1123.73 1363.24 1116.45Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.7302,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1376.14 1090.14C1361 1086.22 1280.26 969.207 1280.26 953.53C1275.77 946.812 1275.77 561.617 1283.06 557.138C1283.06 534.743 1408.1 447.963 1429.41 453.561C1436.14 449.082 1823.03 546.501 1828.08 553.219C1843.22 557.138 1923.96 674.152 1923.96 689.829C1928.45 696.547 1928.45 1081.74 1921.16 1086.22C1921.16 1108.62 1796.12 1195.4 1774.81 1189.8C1767.52 1194.28 1380.63 1096.86 1376.14 1090.14Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.7601,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1389.04 1063.83C1373.34 1059.91 1301 955.21 1300.44 938.414C1296.52 932.255 1296.52 532.504 1302.69 528.585C1302.69 505.07 1415.39 426.687 1438.38 432.286C1444.55 428.367 1846.58 529.704 1850.51 535.863C1866.21 539.782 1938.54 644.479 1939.1 661.275C1943.02 667.434 1943.02 1067.18 1936.86 1071.1C1936.86 1094.62 1824.15 1173 1801.16 1167.4C1795.56 1171.32 1392.96 1069.98 1389.04 1063.83Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.7901,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1401.93 1037.51C1385.67 1033.59 1321.19 940.653 1321.19 923.857C1317.83 918.818 1317.83 503.39 1322.87 500.031C1322.87 475.397 1423.8 405.412 1447.35 411.011C1452.4 407.652 1870.13 512.908 1873.5 517.947C1889.76 521.866 1954.24 614.806 1954.24 631.602C1957.6 636.641 1957.6 1052.07 1952.56 1055.43C1952.56 1080.06 1851.63 1150.05 1828.08 1144.45C1823.03 1148.37 1405.3 1042.55 1401.93 1037.51Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.8201,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1414.83 1011.2C1397.45 1006.72 1341.94 926.656 1341.94 908.74C1339.13 904.261 1338.57 474.277 1343.06 471.477C1343.06 446.283 1431.65 383.577 1456.32 389.736C1460.81 386.936 1893.12 496.112 1895.92 500.591C1913.31 505.07 1968.82 585.132 1968.82 603.048C1971.62 607.527 1972.18 1037.51 1967.7 1040.31C1967.7 1065.51 1879.1 1128.21 1854.43 1122.05C1850.51 1124.85 1417.63 1015.68 1414.83 1011.2Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.8501,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427.73 984.883C1409.78 980.404 1362.12 912.659 1362.12 894.184C1359.88 890.824 1359.32 445.163 1362.68 442.924C1362.68 416.61 1439.5 362.302 1464.73 368.46C1468.1 366.221 1916.11 479.316 1918.35 483.235C1936.3 487.714 1983.96 555.459 1983.96 573.935C1986.2 577.294 1986.76 1022.95 1983.4 1025.19C1983.4 1051.51 1906.58 1105.82 1881.35 1099.66C1877.98 1101.9 1429.97 988.243 1427.73 984.883Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.8801,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440.62 958.569C1422.12 954.09 1382.87 898.662 1382.87 879.067C1381.19 876.267 1380.07 416.05 1382.87 414.37C1382.87 386.936 1447.35 340.467 1474.27 347.185C1477.07 345.505 1940.22 462.519 1941.9 465.319C1960.41 469.798 1999.66 525.225 1999.66 544.821C2001.34 547.62 2002.46 1007.84 1999.66 1009.52C1999.66 1036.95 1935.17 1083.42 1908.26 1076.7C1905.46 1078.38 1442.31 961.369 1440.62 958.569Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.9101,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1453.52 932.255C1434.46 927.216 1403.62 884.105 1403.06 864.51C1401.93 862.83 1400.81 386.936 1402.49 385.816C1402.49 357.263 1455.2 319.191 1482.68 325.91C1484.36 324.79 1962.65 446.283 1963.77 447.962C1982.84 453.001 2013.67 496.112 2014.24 515.707C2015.36 517.387 2016.48 993.281 2014.8 994.401C2014.8 1022.95 1962.09 1061.03 1934.61 1054.31C1933.49 1055.43 1455.2 933.934 1453.52 932.255Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.94,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1466.42 905.941C1446.79 900.902 1423.8 870.109 1423.8 849.953C1423.24 848.834 1421.56 358.382 1422.68 357.823C1422.68 328.709 1463.05 298.476 1491.65 305.194C1492.77 304.634 1986.2 430.047 1986.76 430.606C2006.39 435.645 2029.37 466.438 2029.37 486.594C2029.94 487.714 2031.62 978.165 2030.5 978.725C2030.5 1007.84 1990.12 1038.07 1961.53 1031.35C1960.97 1032.47 1467.54 907.061 1466.42 905.941Z",
    stroke: "#BFD3F3",
    style: {
      stroke: "#BFD3F3",
      stroke: "color(display-p3 0.7490 0.8288 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 0.97,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip1_23065_21773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M561.809 1175.81L59.9681 1360.57C27.4466 1372.33 -7.31785 1348.81 -7.31785 1314.1L-9 818.609C-9 797.894 3.89647 778.858 23.5215 771.58L525.363 586.821C557.884 575.064 592.648 598.578 592.648 633.291L594.331 1128.78C594.331 1150.06 581.434 1168.53 561.809 1175.81Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8108 1319.14L20.1572 827.008C19.5965 805.732 32.493 786.697 52.1181 778.858L550.595 591.3C583.116 578.983 617.881 602.497 618.441 637.21L629.095 1129.34C629.656 1150.62 616.759 1169.65 597.134 1177.49L98.6575 1365.05C66.136 1377.37 31.3716 1353.85 30.8108 1319.14Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.4861,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9395 1324.18L49.8752 834.846C48.7538 813.571 61.0895 793.415 81.2753 785.577L576.388 595.219C608.348 582.902 643.113 605.857 644.795 640.009L663.859 1129.34C664.981 1150.62 652.645 1170.77 632.459 1178.61L137.347 1368.97C105.386 1381.28 70.6217 1358.33 68.9395 1324.18Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.4723,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.629 1329.78L79.5932 843.804C77.911 822.529 90.2468 801.813 110.433 793.415L602.741 600.258C634.702 587.941 669.467 609.776 671.71 643.928L699.745 1129.9C701.427 1151.18 689.092 1171.89 668.906 1180.29L176.597 1373.45C144.076 1385.76 109.311 1363.37 107.629 1329.78Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.4584,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.758 1334.81L109.311 851.642C107.068 829.807 119.404 809.091 139.59 800.133L628.534 604.177C660.495 591.3 695.26 613.135 697.502 646.728L733.949 1129.9C736.192 1151.74 723.856 1172.45 703.67 1181.41L214.726 1377.37C183.326 1390.24 148.001 1368.41 145.758 1334.81Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.4446,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.886 1339.85L138.468 859.48C135.665 837.645 147.44 815.81 168.186 806.852L653.766 608.096C685.167 595.219 720.492 616.494 723.295 649.527L768.713 1129.9C771.517 1151.74 759.742 1173.57 738.995 1182.53L253.415 1381.28C222.015 1394.72 187.251 1373.45 183.886 1339.85Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.4307,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.576 1345.45L168.747 868.438C165.383 846.603 177.158 824.208 197.904 814.69L680.12 613.135C711.52 599.698 746.845 620.413 750.21 654.006L804.038 1131.02C807.403 1152.86 795.628 1175.25 774.881 1184.77L292.665 1386.32C260.704 1399.2 225.94 1378.48 222.576 1345.45Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.4169,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.704 1350.49L197.904 876.277C193.979 853.882 205.194 830.927 227.061 821.409L706.474 617.054C737.874 603.617 772.638 623.773 777.124 656.805L839.924 1131.02C843.849 1153.41 832.635 1176.37 810.767 1185.89L331.355 1390.24C299.955 1403.68 264.629 1383.52 260.704 1350.49Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.403,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.833 1355.53L227.622 884.675C223.136 862.28 234.351 838.765 256.219 828.687L732.267 621.533C763.106 608.096 798.431 627.692 803.478 660.165L874.689 1131.02C879.174 1153.42 867.96 1176.93 846.092 1187.01L370.044 1394.16C338.644 1408.16 303.88 1388.56 298.833 1355.53Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3892,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.523 1361.13L257.34 893.073C252.294 870.118 263.508 846.603 285.376 835.966L758.06 626.012C788.899 612.015 824.224 631.051 829.271 663.524L909.453 1131.58C914.5 1154.53 903.285 1178.05 881.417 1188.69L408.734 1398.64C377.894 1412.64 342.569 1393.04 337.523 1361.13Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3753,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.651 1366.17L287.058 901.471C280.89 878.516 292.105 853.882 314.533 843.244L783.853 630.491C814.692 616.494 850.017 634.97 855.625 667.443L944.218 1132.14C950.386 1155.09 939.171 1179.73 916.743 1190.37L447.423 1403.12C416.584 1416.56 381.819 1398.08 375.651 1366.17Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3615,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.78 1371.21L316.215 909.309C309.487 886.354 320.701 861.16 343.13 849.962L809.646 634.41C839.924 620.414 875.249 638.33 881.978 670.242L979.543 1132.14C986.271 1155.09 975.057 1180.29 952.628 1191.49L486.112 1407.04C455.834 1421.04 420.509 1403.12 413.78 1371.21Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3476,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.469 1376.25L346.494 917.148C339.205 893.633 350.419 868.438 372.848 856.681L835.999 638.33C866.278 623.773 901.603 641.129 908.892 673.042L1014.87 1132.14C1022.16 1155.65 1010.94 1180.85 988.514 1192.61L525.363 1410.96C494.523 1425.51 459.198 1408.16 452.469 1376.25Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3338,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.598 1381.84L375.651 926.106C367.801 902.591 378.455 876.277 401.444 864.519L861.232 643.368C891.51 628.812 926.835 645.608 934.685 676.961L1049.63 1132.7C1057.48 1156.21 1046.83 1182.53 1023.84 1194.29L564.052 1415.44C533.773 1429.99 498.448 1413.2 490.598 1381.84Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3199,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.727 1386.88L405.369 933.944C396.959 910.429 407.612 883.555 430.602 871.238L887.025 647.287C917.303 632.731 952.628 648.967 961.039 679.76L1084.4 1132.7C1092.81 1156.21 1082.15 1183.09 1059.16 1195.41L602.741 1419.36C572.463 1434.47 537.138 1418.24 528.727 1386.88Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3061,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.416 1391.92L435.087 942.342C426.116 918.267 436.209 891.393 459.759 878.516L913.378 651.767C943.096 636.65 978.982 652.326 987.393 683.679L1119.72 1133.26C1128.69 1157.33 1118.6 1184.21 1095.05 1197.09L641.431 1423.84C611.713 1438.95 575.827 1423.28 567.416 1391.92Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.2922,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.545 1397.52L464.805 950.74C455.273 926.665 465.366 898.672 488.916 885.794L939.171 656.246C968.889 641.129 1004.21 656.246 1013.75 687.039L1154.49 1133.82C1164.02 1157.89 1153.93 1185.89 1130.38 1198.76L680.12 1428.31C650.402 1443.43 615.077 1427.75 605.545 1397.52Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.2783,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.674 1402.56L493.962 958.578C483.869 934.504 493.962 905.95 517.512 892.513L964.403 660.165C994.121 645.048 1029.45 659.605 1039.54 689.838L1189.25 1133.82C1199.34 1157.89 1189.25 1186.45 1165.7 1199.88L718.81 1432.23C689.652 1447.91 653.766 1432.79 643.674 1402.56Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.2645,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.363 1407.6L524.241 966.976C513.587 942.342 523.12 913.788 547.23 899.791L990.757 664.644C1019.91 648.967 1055.8 663.524 1066.45 693.197L1224.58 1133.82C1235.23 1158.45 1225.7 1187.01 1201.59 1201L758.06 1436.15C728.342 1451.83 692.456 1437.83 682.363 1407.6Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.2506,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.492 1413.2L553.398 975.375C542.184 950.74 551.716 921.067 575.827 907.07L1016.55 669.123C1045.71 653.446 1081.59 666.883 1092.81 697.116L1259.9 1134.94C1271.12 1159.57 1261.58 1189.25 1237.47 1203.24L796.749 1440.63C767.592 1456.31 731.706 1442.87 720.492 1413.2Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.2368,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.62 1418.24L583.116 983.773C571.341 959.138 580.313 928.905 604.984 914.348L1042.34 673.602C1071.5 657.925 1106.83 670.802 1118.6 700.476L1294.1 1134.94C1305.88 1159.57 1296.91 1189.81 1272.24 1204.36L834.878 1445.11C806.281 1460.79 770.395 1447.91 758.62 1418.24Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.2229,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.31 1423.28L612.834 991.611C600.498 966.417 609.47 936.183 634.141 921.067L1068.14 678.081C1096.73 661.844 1132.62 674.721 1144.95 703.835L1329.43 1135.5C1341.77 1160.69 1332.79 1190.93 1308.12 1206.04L874.128 1449.03C845.531 1465.27 809.646 1452.95 797.31 1423.28Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.2091,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.439 1428.31L641.992 999.449C629.095 974.255 638.067 942.902 662.738 927.785L1093.37 682C1121.96 665.763 1157.85 677.521 1170.75 706.634L1364.19 1135.5C1377.09 1160.69 1368.12 1192.05 1343.45 1207.16L912.817 1452.95C884.221 1469.74 848.335 1457.43 835.439 1428.31Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.1952,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.567 1433.91L671.709 1008.41C658.252 983.213 666.663 951.3 691.895 935.623L1119.72 687.039C1148.32 670.242 1184.2 682 1197.66 710.554L1399.52 1136.06C1412.98 1161.25 1404.57 1193.17 1379.33 1208.84L951.507 1457.43C923.471 1474.22 887.025 1462.47 873.567 1433.91Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.1814,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.257 1438.95L701.427 1016.25C687.409 990.491 695.82 958.018 721.052 942.342L1145.51 690.958C1173.55 674.162 1210 685.359 1224.01 713.913L1434.84 1136.62C1448.86 1162.37 1440.45 1194.85 1415.22 1210.52L990.757 1461.91C962.16 1478.7 926.275 1467.51 912.257 1438.95Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.1675,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.385 1443.99L731.145 1024.64C716.567 998.889 724.977 965.857 750.21 949.62L1171.31 695.437C1199.34 678.64 1235.23 688.718 1250.37 717.272L1469.61 1136.62C1484.19 1162.37 1475.78 1195.41 1450.54 1211.64L1029.45 1465.83C1000.85 1483.18 964.964 1472.54 950.385 1443.99Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.1537,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988.514 1449.59L760.303 1033.04C745.163 1007.29 753.013 973.695 778.806 956.899L1197.1 699.916C1225.14 682.56 1261.02 692.637 1276.16 720.631L1504.37 1137.18C1519.51 1162.93 1511.66 1196.53 1485.87 1213.32L1067.58 1470.3C1040.1 1487.1 1003.65 1477.58 988.514 1449.59Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.1398,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1027.2 1454.63L790.021 1041.44C774.321 1015.13 782.171 980.973 807.964 964.177L1222.89 704.395C1250.37 687.039 1286.82 696.557 1302.52 723.99L1539.14 1137.18C1554.84 1163.49 1546.99 1197.65 1521.19 1214.44L1106.26 1474.22C1078.79 1491.58 1042.9 1482.62 1027.2 1454.63Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.126,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.33 1459.67L819.739 1049.28C803.478 1022.96 810.767 988.252 837.121 971.455L1248.69 708.874C1276.16 691.518 1312.61 699.916 1328.87 727.91L1574.46 1138.3C1590.72 1164.61 1583.43 1199.32 1557.08 1216.12L1145.51 1478.7C1118.04 1496.06 1081.59 1487.66 1065.33 1459.67Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.1121,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.46 1465.27L849.456 1057.68C832.635 1031.36 839.924 996.09 866.278 978.734L1274.48 713.353C1301.95 695.437 1337.84 703.835 1355.22 731.269L1609.23 1138.86C1626.05 1165.17 1618.76 1200.44 1592.41 1217.8L1184.2 1483.18C1156.73 1500.54 1120.28 1492.14 1103.46 1465.27Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.0982481,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142.15 1470.3L879.174 1066.07C861.792 1039.2 869.082 1003.37 895.435 986.012L1300.83 717.832C1327.75 699.916 1364.19 707.754 1382.14 734.628L1645.11 1138.86C1662.49 1165.73 1655.21 1201.56 1628.85 1218.92L1222.89 1487.1C1195.98 1505.02 1159.53 1497.18 1142.15 1470.3Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.0843946,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180.28 1475.34L908.892 1073.91C890.95 1047.04 897.678 1010.65 924.593 992.731L1326.63 721.751C1353.54 703.835 1389.99 710.553 1407.93 737.427L1679.32 1138.86C1697.26 1165.73 1690.53 1202.12 1663.62 1220.04L1261.58 1491.02C1234.67 1509.5 1198.22 1502.22 1180.28 1475.34Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.0705411,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.18 1449.03C1192.61 1449.03 929.078 1059.92 929.078 1059.36C911.696 1033.6 918.425 981.533 944.218 964.177C944.218 963.057 1333.92 699.916 1335.04 700.476C1360.83 683.119 1412.98 693.757 1430.36 720.071C1430.92 720.071 1694.46 1109.18 1694.46 1109.74C1711.84 1135.5 1705.11 1187.57 1679.32 1204.92C1679.32 1206.04 1289.62 1469.18 1288.5 1468.62C1262.7 1485.98 1210.56 1475.34 1193.18 1449.03Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.1005,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.07 1422.72C1204.95 1422.16 949.825 1045.92 949.825 1044.24C933.003 1019.04 939.171 952.42 964.403 935.623C964.403 933.944 1342.33 678.641 1344.01 679.2C1369.24 662.404 1435.97 676.961 1453.35 702.155C1454.47 702.715 1709.59 1078.95 1709.59 1080.63C1726.42 1105.83 1720.25 1172.45 1695.02 1189.25C1695.02 1190.93 1317.09 1446.23 1315.41 1445.67C1290.18 1463.03 1222.89 1447.91 1206.07 1422.72Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.1305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1218.97 1396.96C1216.73 1396.4 970.571 1032.48 970.571 1030.24C954.31 1006.17 960.478 923.866 984.589 907.63C984.589 904.83 1350.18 657.925 1352.98 658.485C1377.09 642.249 1459.52 660.725 1475.78 685.359C1478.02 685.919 1724.17 1049.84 1724.17 1052.08C1740.43 1076.15 1734.27 1158.45 1710.16 1174.69C1710.16 1177.49 1344.57 1424.39 1341.77 1423.83C1317.65 1440.07 1235.23 1421.04 1218.97 1396.96Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.1605,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.86 1370.65C1229.06 1370.09 990.757 1017.93 990.757 1015.13C975.057 991.611 980.664 894.752 1004.21 879.076C1004.21 875.157 1358.03 636.09 1361.95 637.21C1385.5 621.533 1483.07 644.488 1498.77 667.443C1501.57 668.003 1739.87 1020.16 1739.87 1022.96C1755.57 1046.48 1749.97 1143.34 1726.42 1159.01C1726.42 1162.93 1372.6 1402 1368.68 1400.88C1345.13 1416.56 1247.56 1393.6 1231.86 1370.65Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.1905,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.76 1344.33C1241.4 1343.77 1011.5 1003.93 1011.5 1000.57C996.364 978.174 1001.97 865.639 1024.4 850.522C1024.4 845.483 1365.88 614.815 1370.92 615.934C1393.35 600.818 1506.06 627.692 1521.19 650.087C1524.56 650.647 1754.45 990.491 1754.45 993.85C1769.59 1016.25 1763.98 1128.78 1741.56 1143.9C1741.56 1148.94 1400.08 1379.6 1395.03 1378.48C1372.6 1393.6 1259.9 1366.73 1244.76 1344.33Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.2205,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1257.66 1318.02C1253.73 1316.9 1032.25 989.931 1031.69 985.452C1017.11 963.617 1022.16 836.525 1044.02 821.969C1044.02 816.37 1373.73 592.98 1379.33 594.659C1401.2 580.102 1529.04 610.896 1543.62 632.171C1547.55 633.291 1769.03 960.258 1769.59 964.737C1784.17 986.572 1779.12 1113.66 1757.26 1128.22C1757.26 1133.82 1427.55 1357.21 1421.95 1355.53C1400.08 1370.09 1272.24 1339.85 1257.66 1318.02Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.2504,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270.55 1291.7C1266.07 1290.58 1052.44 975.935 1052.44 970.896C1038.42 950.18 1043.46 807.412 1064.21 793.415C1064.21 786.697 1381.58 571.704 1388.3 573.384C1409.05 559.387 1552.03 594.099 1566.05 614.815C1570.54 615.935 1784.17 930.585 1784.17 935.624C1798.19 956.339 1793.14 1099.11 1772.4 1113.1C1772.4 1119.82 1455.03 1334.81 1448.3 1333.14C1428.12 1347.13 1284.57 1312.42 1270.55 1291.7Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.2804,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1283.45 1265.39C1278.4 1264.27 1073.18 961.378 1073.18 956.339C1059.72 936.183 1064.21 778.858 1084.4 765.421C1084.4 757.583 1389.99 550.989 1397.28 552.669C1417.46 539.232 1575.58 577.863 1589.04 597.459C1594.09 598.578 1799.31 901.471 1799.31 906.51C1812.77 926.665 1808.28 1083.99 1788.1 1097.43C1788.1 1105.27 1482.5 1311.86 1475.22 1310.18C1455.59 1324.18 1296.91 1285.55 1283.45 1265.39Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3104,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1296.35 1239.08C1290.18 1237.4 1093.37 947.381 1093.37 941.222C1080.47 922.186 1084.96 749.185 1104.02 736.308C1104.02 727.35 1397.28 528.594 1406.25 530.833C1425.31 517.956 1599.13 560.507 1612.03 579.543C1618.2 581.222 1815.01 871.238 1815.01 877.396C1827.91 896.432 1823.42 1069.43 1804.36 1082.31C1804.36 1091.27 1511.1 1290.02 1502.13 1287.78C1483.07 1300.66 1309.24 1258.11 1296.35 1239.08Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3404,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1309.24 1212.76C1302.51 1211.08 1114.11 933.384 1114.11 926.665C1101.78 908.749 1106.26 720.631 1124.21 708.314C1124.21 698.796 1405.69 507.878 1415.22 510.118C1433.16 497.801 1622.12 544.27 1634.46 562.186C1641.19 563.866 1829.59 841.564 1829.59 848.283C1841.92 866.199 1837.44 1054.32 1819.5 1066.63C1819.5 1076.15 1538.02 1267.07 1528.48 1264.83C1510.54 1277.71 1321.58 1231.24 1309.24 1212.76Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3704,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1322.14 1186.45C1314.85 1184.77 1134.86 919.387 1134.86 911.549C1123.09 894.193 1127.01 690.958 1144.39 679.76C1144.39 669.123 1413.54 486.043 1424.19 488.843C1441.57 477.085 1645.67 527.474 1657.45 544.83C1664.74 546.51 1844.73 811.891 1844.73 819.729C1856.5 837.085 1852.58 1040.32 1835.2 1051.52C1835.2 1062.16 1566.05 1245.23 1555.4 1242.44C1538.02 1254.19 1333.91 1203.8 1322.14 1186.45Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.4003,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335.04 1160.13C1327.19 1157.89 1155.05 904.83 1155.05 896.992C1143.83 880.756 1147.76 662.404 1164.02 651.207C1164.02 639.449 1421.39 464.768 1432.6 467.567C1448.86 456.37 1668.66 510.678 1679.32 527.474C1687.17 529.714 1859.31 782.777 1859.31 790.616C1870.52 806.852 1866.6 1025.2 1850.33 1036.4C1850.33 1048.16 1592.97 1222.84 1581.75 1220.04C1565.49 1231.24 1346.25 1176.93 1335.04 1160.13Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.4303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1348.49 1134.38C1340.08 1132.14 1176.35 891.393 1176.35 882.435C1165.7 866.759 1169.06 633.291 1184.76 623.213C1184.76 610.336 1429.8 444.053 1442.13 446.852C1457.83 436.214 1692.21 494.441 1702.87 510.118C1711.28 512.357 1875.01 753.104 1875.01 762.062C1885.66 777.738 1882.3 1011.21 1866.6 1021.28C1866.6 1034.16 1621.56 1200.44 1609.23 1197.65C1593.53 1207.72 1358.59 1149.5 1348.49 1134.38Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.4603,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1361.39 1108.06C1351.86 1105.83 1196.54 877.396 1196.54 867.878C1186.45 853.322 1189.81 604.737 1204.39 594.659C1204.39 581.222 1437.65 422.217 1451.1 425.577C1465.68 415.499 1715.76 477.645 1725.86 492.762C1735.39 495.001 1890.71 723.43 1890.71 732.948C1900.8 747.505 1897.43 996.09 1882.86 1006.17C1882.86 1019.6 1649.6 1178.61 1636.14 1175.25C1621 1184.77 1370.92 1122.62 1361.39 1108.06Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.4903,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1374.29 1081.75C1364.19 1079.51 1217.29 863.399 1217.29 852.762C1207.75 838.765 1210.56 575.064 1224.58 566.106C1224.58 551.549 1445.5 400.942 1460.08 404.302C1474.09 394.784 1738.75 460.849 1748.28 474.846C1758.38 477.085 1905.29 693.197 1905.29 703.835C1914.82 717.832 1912.01 981.533 1898 990.491C1898 1005.05 1677.07 1155.65 1662.49 1152.3C1648.48 1161.81 1383.26 1095.75 1374.29 1081.75Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.5203,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.18 1055.44C1376.53 1052.64 1238.03 848.843 1238.03 838.205C1229.06 825.328 1231.86 546.51 1244.76 537.552C1244.76 521.875 1453.91 379.107 1469.05 383.026C1481.94 374.068 1762.3 444.053 1771.27 457.49C1781.93 460.289 1920.42 664.084 1920.42 674.721C1929.4 687.598 1926.59 966.416 1913.7 975.374C1913.7 991.051 1704.55 1133.82 1689.41 1129.9C1675.95 1138.3 1395.59 1068.31 1387.18 1055.44Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.5503,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1400.08 1029.12C1388.87 1026.32 1258.22 834.846 1258.22 823.088C1249.81 810.771 1252.05 516.837 1264.39 508.998C1264.39 492.202 1461.76 357.832 1477.46 361.751C1489.79 353.353 1785.29 427.816 1793.14 439.574C1804.36 442.373 1935 633.851 1935 645.608C1943.41 657.925 1941.17 951.86 1928.84 959.698C1928.84 976.494 1731.46 1110.86 1715.76 1106.95C1703.43 1115.34 1407.93 1041.44 1400.08 1029.12Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.5802,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1412.98 1002.81C1401.2 1000.01 1278.96 820.849 1278.96 808.531C1271.11 797.334 1273.36 488.283 1284.57 480.444C1284.57 463.088 1469.61 335.997 1486.43 340.476C1497.64 332.637 1808.28 411.02 1816.13 422.217C1827.91 425.017 1950.14 604.177 1950.14 616.494C1957.99 627.692 1955.75 936.743 1944.54 944.581C1944.54 961.937 1759.5 1089.03 1742.68 1084.55C1731.46 1091.83 1420.27 1014.01 1412.98 1002.81Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.6102,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1425.87 976.494C1413.54 973.135 1299.15 806.852 1299.15 793.975C1291.86 783.337 1293.54 459.169 1304.2 452.451C1304.2 433.975 1477.46 315.281 1495.4 319.76C1506.06 312.482 1831.83 394.784 1838.56 404.861C1850.9 408.221 1965.28 574.504 1965.28 587.381C1972.57 598.018 1970.89 922.186 1960.24 928.905C1960.24 947.381 1786.97 1066.07 1769.03 1061.6C1758.94 1068.87 1432.6 987.132 1425.87 976.494Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.6402,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1438.77 950.18C1425.31 946.821 1319.9 792.295 1319.9 778.858C1313.73 769.34 1314.85 430.056 1324.38 423.337C1324.38 403.742 1485.31 293.446 1504.37 297.925C1513.91 291.766 1855.38 377.427 1861.55 386.945C1875.01 390.305 1980.42 544.83 1980.42 558.267C1986.59 567.785 1985.47 907.07 1975.94 913.788C1975.94 933.384 1815.01 1043.68 1795.95 1039.2C1786.41 1045.92 1444.94 959.698 1438.77 950.18Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.6702,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1451.67 923.866C1437.65 920.507 1340.64 778.298 1340.64 764.302C1335.04 755.903 1335.6 400.942 1344.57 395.343C1344.57 374.628 1493.72 272.171 1513.34 277.21C1521.75 271.611 1878.37 361.191 1884.54 369.589C1898.56 372.948 1995.56 515.157 1995.56 529.154C2001.17 537.552 2000.61 892.513 1991.64 898.112C1991.64 918.827 1842.48 1021.28 1822.86 1016.25C1813.89 1022.4 1457.27 932.824 1451.67 923.866Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.7002,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1464.56 898.112C1449.98 894.193 1360.83 764.861 1360.83 749.745C1355.78 741.907 1356.34 372.389 1364.19 367.35C1364.19 346.074 1501.01 251.455 1521.76 256.494C1529.61 250.896 1901.36 344.955 1906.97 352.793C1921.55 356.712 2010.7 486.043 2010.7 501.16C2015.75 508.998 2015.19 878.516 2007.34 883.555C2007.34 904.83 1870.52 999.449 1849.77 994.41C1841.36 999.449 1469.61 905.39 1464.56 898.112Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.7302,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1477.46 871.797C1462.32 867.878 1381.58 750.864 1381.58 735.188C1377.09 728.469 1377.09 343.275 1384.38 338.796C1384.38 316.401 1509.42 229.62 1530.73 235.219C1537.46 230.74 1924.35 328.158 1929.4 334.877C1944.54 338.796 2025.28 455.81 2025.28 471.486C2029.76 478.205 2029.76 863.399 2022.47 867.878C2022.47 890.273 1897.44 977.054 1876.13 971.455C1868.84 975.934 1481.94 878.516 1477.46 871.797Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.7601,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1490.36 845.483C1474.65 841.564 1402.32 736.868 1401.76 720.071C1397.84 713.913 1397.84 314.161 1404 310.242C1404 286.728 1516.71 208.345 1539.7 213.944C1545.87 210.025 1947.9 311.362 1951.82 317.521C1967.52 321.44 2039.86 426.137 2040.42 442.933C2044.34 449.091 2044.34 848.843 2038.17 852.762C2038.17 876.277 1925.47 954.659 1902.48 949.06C1896.87 952.979 1494.28 851.642 1490.36 845.483Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.7901,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1503.25 819.169C1486.99 815.25 1422.51 722.311 1422.51 705.515C1419.14 700.476 1419.14 285.048 1424.19 281.689C1424.19 257.054 1525.12 187.07 1548.67 192.669C1553.72 189.309 1971.45 294.566 1974.81 299.605C1991.07 303.524 2055.56 396.463 2055.56 413.26C2058.92 418.298 2058.92 833.726 2053.87 837.085C2053.87 861.72 1952.95 931.704 1929.4 926.106C1924.35 930.025 1506.62 824.208 1503.25 819.169Z",
    stroke: "#EEF3FC",
    style: {
      stroke: "#EEF3FC",
      stroke: "color(display-p3 0.9333 0.9529 0.9882)",
      strokeOpacity: 1
    },
    strokeWidth: 0.8201,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-942.881 -844.823L-850.126 -936.795C-822.73 -963.8 -778.505 -963.8 -751.501 -936.404L269.197 92.1214C296.202 119.517 296.202 163.742 268.806 190.747L176.051 282.719C148.655 309.724 104.429 309.724 77.4248 282.328L-943.273 -746.197C-970.277 -773.593 -970.277 -817.427 -942.881 -844.823Z",
    stroke: "#9FBEED",
    style: {
      stroke: "#9FBEED",
      stroke: "color(display-p3 0.6235 0.7431 0.9294)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3529,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-935.054 -814.296L-819.991 -928.577C-792.203 -955.973 -747.587 -955.973 -720.191 -928.185L261.37 60.4197C288.766 88.2071 288.766 132.823 260.978 160.219L145.915 274.5C118.127 301.896 73.5111 301.896 46.115 274.109L-935.445 -714.496C-962.841 -741.892 -962.45 -786.9 -935.054 -814.296Z",
    stroke: "#9FBEED",
    style: {
      stroke: "#9FBEED",
      stroke: "color(display-p3 0.6235 0.7431 0.9294)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3529,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-927.227 -783.769L-789.464 -920.358C-761.677 -948.145 -716.277 -948.145 -688.49 -919.966L253.542 28.7188C281.329 56.5062 281.329 101.905 253.15 129.693L115.388 266.281C87.6002 294.069 42.201 294.069 14.4136 265.89L-927.227 -682.795C-955.014 -710.583 -955.014 -755.982 -927.227 -783.769Z",
    stroke: "#9FBEED",
    style: {
      stroke: "#9FBEED",
      stroke: "color(display-p3 0.6235 0.7431 0.9294)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3529,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-919.008 -753.242L-758.937 -912.139C-730.758 -940.317 -684.967 -939.926 -656.789 -911.747L245.715 -2.98205C273.893 25.1967 273.502 70.9873 245.323 99.1661L85.2522 258.063C57.0735 286.242 11.283 285.85 -16.8958 257.672L-919.399 -651.094C-947.578 -679.272 -947.578 -725.063 -919.008 -753.242Z",
    stroke: "#9FBEED",
    style: {
      stroke: "#9FBEED",
      stroke: "color(display-p3 0.6235 0.7431 0.9294)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3529,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-911.18 -722.715L-728.41 -904.311C-699.84 -932.881 -653.658 -932.49 -625.088 -903.92L237.887 -34.6829C266.457 -6.11273 266.066 40.0692 237.496 68.6393L54.7251 250.236C26.155 278.806 -20.0269 278.415 -48.597 249.844L-911.572 -619.392C-940.142 -647.962 -939.751 -694.144 -911.18 -722.715Z",
    stroke: "#9FBEED",
    style: {
      stroke: "#9FBEED",
      stroke: "color(display-p3 0.6235 0.7431 0.9294)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3529,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-903.353 -692.187L-697.883 -896.092C-668.921 -924.662 -622.348 -924.662 -593.386 -895.7L229.669 -66.3835C258.239 -37.422 258.239 9.15127 229.277 38.1128L23.8071 242.018C-5.15444 270.588 -51.7277 270.588 -80.6892 241.626L-903.744 -587.691C-932.314 -616.652 -932.314 -663.225 -903.353 -692.187Z",
    stroke: "#9FBEED",
    style: {
      stroke: "#9FBEED",
      stroke: "color(display-p3 0.6235 0.7431 0.9294)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3529,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-895.526 -661.661L-667.747 -887.873C-638.394 -916.835 -591.038 -916.835 -562.077 -887.482L221.449 -98.085C250.411 -68.7321 250.411 -21.3761 221.058 7.58538L-6.72024 233.798C-36.0731 262.76 -83.4291 262.76 -112.391 233.407L-895.917 -555.99C-924.878 -585.343 -924.487 -632.308 -895.526 -661.661Z",
    stroke: "#9FBEED",
    style: {
      stroke: "#9FBEED",
      stroke: "color(display-p3 0.6235 0.7431 0.9294)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3529,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-887.307 -631.133L-636.829 -879.654C-607.085 -909.007 -559.337 -909.007 -529.984 -879.263L214.013 -129.786C243.366 -100.042 243.366 -52.2942 213.622 -22.9413L-36.8559 225.58C-66.6001 254.933 -114.347 254.933 -143.7 225.188L-887.698 -524.289C-917.051 -554.033 -917.051 -601.78 -887.307 -631.133Z",
    stroke: "#9FBEED",
    style: {
      stroke: "#9FBEED",
      stroke: "color(display-p3 0.6235 0.7431 0.9294)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3529,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-879.479 -600.606L-606.693 -871.435C-576.949 -901.18 -528.418 -900.788 -498.674 -871.044L205.795 -161.487C235.539 -131.743 235.148 -83.2124 205.404 -53.4682L-67.3824 217.752C-97.1267 247.497 -145.657 247.105 -175.401 217.361L-879.87 -492.196C-909.615 -522.332 -909.615 -570.862 -879.479 -600.606Z",
    stroke: "#9FBEED",
    style: {
      stroke: "#9FBEED",
      stroke: "color(display-p3 0.6235 0.7431 0.9294)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3529,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-871.652 -570.08L-576.166 -863.609C-546.03 -893.744 -497.109 -893.353 -466.973 -863.217L197.967 -193.189C228.103 -163.053 227.712 -114.132 197.576 -83.9959L-97.9098 209.533C-128.045 239.669 -176.967 239.277 -207.102 209.142L-872.043 -460.887C-902.179 -491.023 -901.787 -539.944 -871.652 -570.08Z",
    stroke: "#9FBEED",
    style: {
      stroke: "#9FBEED",
      stroke: "color(display-p3 0.6235 0.7431 0.9294)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3529,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-863.824 -539.552L-545.639 -855.389C-515.112 -885.916 -465.799 -885.525 -435.272 -854.998L190.14 -224.889C220.667 -194.362 220.276 -145.049 189.749 -114.522L-128.437 201.315C-158.964 231.842 -208.276 231.45 -238.803 200.923L-864.216 -429.185C-894.351 -459.712 -894.351 -509.025 -863.824 -539.552Z",
    stroke: "#9FBEED",
    style: {
      stroke: "#9FBEED",
      stroke: "color(display-p3 0.6235 0.7431 0.9294)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3529,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-855.997 -509.026L-515.504 -847.171C-484.585 -877.698 -434.881 -877.698 -403.963 -846.78L181.921 -256.591C212.448 -225.673 212.448 -175.968 181.53 -145.05L-158.964 193.095C-189.882 223.622 -239.586 223.622 -270.505 192.704L-856.388 -397.485C-886.915 -428.403 -886.524 -478.107 -855.997 -509.026Z",
    stroke: "#9FBEED",
    style: {
      stroke: "#9FBEED",
      stroke: "color(display-p3 0.6235 0.7431 0.9294)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3529,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-847.778 -478.499L-484.585 -838.953C-453.275 -869.871 -402.788 -869.871 -371.87 -838.561L174.485 -288.293C205.403 -256.983 205.403 -206.496 174.094 -175.577L-189.099 184.876C-220.409 215.794 -270.896 215.794 -301.814 184.484L-848.169 -365.784C-879.088 -397.094 -879.088 -447.581 -847.778 -478.499Z",
    stroke: "#9FBEED",
    style: {
      stroke: "#9FBEED",
      stroke: "color(display-p3 0.6235 0.7431 0.9294)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3529,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-839.95 -447.971L-454.058 -831.124C-422.357 -862.434 -371.478 -862.434 -340.169 -830.733L166.658 -319.992C197.967 -288.291 197.967 -237.413 166.266 -206.103L-219.626 177.05C-251.327 208.36 -302.206 208.36 -333.515 176.658L-840.342 -334.082C-871.652 -365.783 -871.652 -416.661 -839.95 -447.971Z",
    stroke: "#9FBEED",
    style: {
      stroke: "#9FBEED",
      stroke: "color(display-p3 0.6235 0.7431 0.9294)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3529,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-832.123 -417.445L-423.922 -822.514C-392.221 -854.216 -340.56 -853.824 -308.859 -822.123L158.439 -351.303C190.14 -319.602 189.749 -267.941 158.048 -236.24L-250.153 168.83C-281.854 200.531 -333.515 200.14 -365.217 168.439L-832.514 -302.381C-864.216 -334.082 -863.824 -385.744 -832.123 -417.445Z",
    stroke: "#9FBEED",
    style: {
      stroke: "#9FBEED",
      stroke: "color(display-p3 0.6235 0.7431 0.9294)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3529,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-396.918 160.22L-824.687 -270.68C-856.78 -302.773 -856.388 -354.825 -824.296 -386.918L-393.396 -814.687C-361.303 -846.78 -309.251 -846.388 -277.158 -814.296L150.611 -383.396C182.704 -351.303 182.312 -299.251 150.22 -267.158L-280.68 160.611C-312.773 192.704 -364.825 192.312 -396.918 160.22Z",
    stroke: "#9FBEED",
    style: {
      stroke: "#9FBEED",
      stroke: "color(display-p3 0.6235 0.7431 0.9294)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3529,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-427.445 168.048L-832.514 -240.153C-864.216 -271.854 -863.824 -323.515 -832.123 -355.217L-361.694 -822.514C-329.993 -854.216 -278.332 -853.824 -246.631 -822.123L158.83 -413.922C190.531 -382.221 190.14 -330.56 158.439 -298.859L-312.381 168.439C-344.082 200.14 -395.744 200.14 -427.445 168.048Z",
    stroke: "#9FBEED",
    style: {
      stroke: "#9FBEED",
      stroke: "color(display-p3 0.6235 0.7431 0.9294)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3529,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-457.971 175.875L-841.124 -210.017C-872.434 -241.719 -872.434 -292.597 -840.733 -323.907L-329.992 -830.342C-298.291 -861.652 -247.413 -861.652 -216.103 -829.95L167.05 -444.058C198.36 -412.357 198.36 -361.478 166.658 -330.169L-344.082 176.267C-375.783 207.576 -426.661 207.576 -457.971 175.875Z",
    stroke: "#9FBEED",
    style: {
      stroke: "#9FBEED",
      stroke: "color(display-p3 0.6235 0.7431 0.9294)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3529,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-488.499 184.094L-848.953 -179.099C-879.871 -210.409 -879.871 -260.896 -848.561 -291.814L-298.293 -838.169C-266.983 -869.088 -216.496 -869.088 -185.577 -837.778L174.876 -474.585C205.794 -443.275 205.794 -392.788 174.484 -361.87L-375.784 184.485C-407.094 215.403 -457.581 215.012 -488.499 184.094Z",
    stroke: "#9FBEED",
    style: {
      stroke: "#9FBEED",
      stroke: "color(display-p3 0.6235 0.7431 0.9294)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3529,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-519.026 191.922L-857.171 -148.572C-887.698 -179.49 -887.698 -229.194 -856.78 -260.113L-266.591 -846.388C-235.673 -876.915 -185.968 -876.915 -155.05 -845.996L183.095 -505.503C213.622 -474.585 213.622 -424.88 182.704 -393.962L-407.485 192.313C-438.403 222.84 -488.107 222.84 -519.026 191.922Z",
    stroke: "#9FBEED",
    style: {
      stroke: "#9FBEED",
      stroke: "color(display-p3 0.6235 0.7431 0.9294)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3529,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-549.552 199.749L-865.389 -118.437C-895.916 -148.964 -895.525 -198.276 -864.998 -228.803L-234.889 -854.216C-204.362 -884.743 -155.049 -884.351 -124.522 -853.824L191.315 -535.639C221.842 -505.112 221.45 -455.799 190.923 -425.272L-439.185 200.14C-469.712 230.667 -519.025 230.276 -549.552 199.749Z",
    stroke: "#9FBEED",
    style: {
      stroke: "#9FBEED",
      stroke: "color(display-p3 0.6235 0.7431 0.9294)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3529,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-580.08 207.576L-873.609 -87.9098C-903.744 -118.045 -903.353 -166.967 -873.217 -197.102L-203.189 -862.043C-173.053 -892.179 -124.132 -891.787 -93.9959 -861.652L199.533 -566.166C229.669 -536.03 229.277 -487.109 199.142 -456.973L-470.887 207.967C-501.023 238.103 -549.944 237.712 -580.08 207.576Z",
    stroke: "#9FBEED",
    style: {
      stroke: "#9FBEED",
      stroke: "color(display-p3 0.6235 0.7431 0.9294)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3529,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-610.606 215.404L-881.435 -57.3821C-911.18 -87.1264 -910.788 -135.657 -881.044 -165.401L-171.487 -869.87C-141.743 -899.614 -93.2124 -899.223 -63.4682 -869.479L207.752 -596.301C237.497 -566.557 237.105 -518.027 207.361 -488.282L-502.196 216.187C-532.332 245.54 -580.862 245.54 -610.606 215.404Z",
    stroke: "#9FBEED",
    style: {
      stroke: "#9FBEED",
      stroke: "color(display-p3 0.6235 0.7431 0.9294)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3529,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-641.133 223.622L-889.654 -26.856C-919.007 -56.6002 -919.007 -104.348 -889.263 -133.7L-139.786 -877.698C-110.042 -907.051 -62.2942 -907.051 -32.9413 -877.307L215.58 -626.829C244.933 -597.085 244.933 -549.337 215.188 -519.984L-534.289 224.013C-564.033 253.366 -611.78 252.975 -641.133 223.622Z",
    stroke: "#9FBEED",
    style: {
      stroke: "#9FBEED",
      stroke: "color(display-p3 0.6235 0.7431 0.9294)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3529,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-671.661 231.45L-897.873 3.67177C-926.835 -25.6811 -926.835 -73.0371 -897.482 -101.999L-108.085 -885.916C-78.7321 -914.878 -31.3761 -914.878 -2.41462 -885.525L223.798 -657.747C252.76 -628.394 252.76 -581.038 223.407 -552.076L-565.99 231.841C-595.343 260.803 -642.308 260.803 -671.661 231.45Z",
    stroke: "#9FBEED",
    style: {
      stroke: "#9FBEED",
      stroke: "color(display-p3 0.6235 0.7431 0.9294)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3529,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-702.188 239.277L-906.093 33.807C-934.663 4.84551 -934.663 -41.7277 -905.701 -70.6892L-76.3845 -893.744C-47.4229 -922.314 -0.84971 -922.314 28.1118 -893.353L232.017 -687.883C260.587 -658.921 260.587 -612.348 231.625 -583.386L-597.692 239.669C-626.653 268.63 -673.226 268.239 -702.188 239.277Z",
    stroke: "#9FBEED",
    style: {
      stroke: "#9FBEED",
      stroke: "color(display-p3 0.6235 0.7431 0.9294)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3529,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-732.715 247.104L-914.311 64.3338C-942.881 35.7637 -942.49 -10.4182 -913.92 -38.9884L-44.6829 -901.572C-16.1127 -930.142 30.0692 -929.751 58.6393 -901.18L240.236 -718.41C268.806 -689.84 268.415 -643.658 239.844 -615.088L-629.392 247.496C-657.962 276.066 -704.144 275.674 -732.715 247.104Z",
    stroke: "#9FBEED",
    style: {
      stroke: "#9FBEED",
      stroke: "color(display-p3 0.6235 0.7431 0.9294)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3529,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-763.242 255.324L-922.139 95.253C-950.317 67.0742 -949.926 21.2837 -921.747 -6.89507L-12.9821 -909.398C15.1967 -937.577 60.9873 -937.186 89.1661 -909.007L248.063 -748.936C276.242 -720.757 275.85 -674.967 247.672 -646.788L-661.094 255.715C-689.272 283.503 -735.063 283.503 -763.242 255.324Z",
    stroke: "#9FBEED",
    style: {
      stroke: "#9FBEED",
      stroke: "color(display-p3 0.6235 0.7431 0.9294)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3529,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-793.769 263.151L-930.358 125.388C-958.145 97.6006 -958.145 52.2013 -929.966 24.4139L18.719 -917.227C46.5064 -945.014 91.9055 -945.014 119.693 -916.835L256.282 -779.072C284.069 -751.285 284.069 -705.886 255.89 -678.098L-692.795 263.542C-720.582 291.33 -765.981 290.938 -793.769 263.151Z",
    stroke: "#9FBEED",
    style: {
      stroke: "#9FBEED",
      stroke: "color(display-p3 0.6235 0.7431 0.9294)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3529,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-824.295 270.978L-938.576 155.914C-965.972 128.127 -965.972 83.5105 -938.184 56.1145L50.4207 -925.446C78.2081 -952.842 122.824 -952.842 150.22 -925.055L264.501 -809.991C291.897 -782.204 291.897 -737.588 264.11 -710.191L-724.495 271.369C-751.892 298.765 -796.899 298.765 -824.295 270.978Z",
    stroke: "#9FBEED",
    style: {
      stroke: "#9FBEED",
      stroke: "color(display-p3 0.6235 0.7431 0.9294)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3529,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-854.823 278.806L-946.795 186.442C-973.8 159.046 -973.8 114.821 -946.404 87.8162L82.1215 -933.273C109.518 -960.277 153.742 -960.277 180.747 -932.881L272.719 -840.126C299.724 -812.73 299.724 -768.505 272.328 -741.501L-756.197 279.197C-783.593 306.202 -827.427 306.202 -854.823 278.806Z",
    stroke: "#9FBEED",
    style: {
      stroke: "#9FBEED",
      stroke: "color(display-p3 0.6235 0.7431 0.9294)",
      strokeOpacity: 1
    },
    strokeWidth: 0.3529,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23065_21773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 900,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_23065_21773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2161,
    height: 1440,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(-95 -49)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReconciliationAuthBg);
export default __webpack_public_path__ + "static/media/reconciliation-auth-bg.7fb2abcbeafc0437ea1ebd964e58e47e.svg";
export { ForwardRef as ReactComponent };